import { defineMessages } from 'react-intl';

export const i18n: {
	subHeading: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	createdBy: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	emptyHeading: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	emptyContent: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	createPost: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	error: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	loading: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	postedBy: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	excerptPostedOn: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	loadMore: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	subHeading: {
		id: 'blog-posts-macro.sub-heading',
		description: 'Sub-heading for the blog posts titles list',
		defaultMessage: 'Blog Posts',
	},
	createdBy: {
		id: 'blog-posts-macro.created-by',
		description: 'Text shown between the blog title and creator name',
		defaultMessage: 'created by',
	},
	emptyHeading: {
		id: 'blog-posts-macro.empty-heading',
		description: 'Heading for empty state when no blog posts found',
		defaultMessage: 'Blog stream',
	},
	emptyContent: {
		id: 'blog-posts-macro.empty-content',
		description: 'Content text for empty state when no blog posts found',
		defaultMessage:
			'Create a blog post to share news and announcements with your team and company.',
	},
	createPost: {
		id: 'blog-posts-macro.create-post',
		description: 'Button label for creating a new blog post',
		defaultMessage: 'Create blog post',
	},
	error: {
		id: 'blog-posts-macro.error',
		description: 'Generic error message when the macro fails to render',
		defaultMessage: 'Unable to display blog posts.',
	},
	loading: {
		id: 'blog-posts-macro.loading',
		description: 'Loading message while fetching blog posts',
		defaultMessage: 'Loading blog posts…',
	},
	postedBy: {
		id: 'blog-posts-macro.posted-by',
		description: 'Metadata line shown below the blog post title with the author name and date',
		defaultMessage: '{author} posted on {date}',
	},
	excerptPostedOn: {
		id: 'blog-posts-macro.excerpt-posted-on',
		description: 'Date portion of the metadata line shown in excerpts/entire view',
		defaultMessage: 'posted on {date}',
	},
	loadMore: {
		id: 'blog-posts-macro.load-more',
		description: 'Button label for loading the next page of blog posts in entire mode',
		defaultMessage: 'Load more blogs...',
	},
});
